import React from 'react';
import { LegalPage } from '../components/LegalPage';
import { digitalDeliveryPolicy } from '../data/legal';
export function DigitalDeliveryPolicyPage() {
  return <LegalPage document={digitalDeliveryPolicy} data-id="element-208" data-mp="21b4zzx5lyejh" />;
}